import { LOCATION_CHANGE, LocationChangePayload, push } from 'connected-react-router';
import { ActionType, createAction } from 'typesafe-actions';

import { logoutAsync } from '@bolteu/redux-session';

import { AccountActions } from 'rdx/account/actions';
import { MenuActions } from 'rdx/menu';
import { PromotionsPermissionsAction } from 'rdx/promotions/actions';
import { SupportActions } from 'rdx/support/actions';
import { TargetingParametersActions } from 'rdx/targetingParameters/actions';

import { NotificationsActions } from './notifications';
import { OfflinePeriodsActions } from './offlinePeriods';
import { PasswordActions } from './password';
import { ScheduleActions } from './schedule';

export const emptyAction = createAction('@providerApp/EMPTY_ACTION')();
export const routeChangeAction = createAction(LOCATION_CHANGE)<LocationChangePayload>();

const allActions = {
  emptyAction,
  routeChangeAction,
  logoutAsync,
};

export type GlobalAppActions =
  | ActionType<typeof allActions>
  | AccountActions
  | MenuActions
  | NotificationsActions
  | PasswordActions
  | ScheduleActions
  | SupportActions
  | TargetingParametersActions
  | PromotionsPermissionsAction
  | ActionType<typeof push>
  | OfflinePeriodsActions;
